import {UserDetailed} from '@/domain/models/UserDetailed';
import {isKeyInObject} from '@/shared/lib/object';

export function isUserDetailedModel(user: unknown): user is UserDetailed {
  return (
    isKeyInObject('id', user) &&
    isKeyInObject('nickname', user) &&
    isKeyInObject('gender', user) &&
    isKeyInObject('height_sm', user) &&
    isKeyInObject('weight_kg', user)
  );
}
